import HeaderFilter from '../../../components/HeaderFilter';
import ProductTable from './ProductTable';
import ProductForm from './ProductForm';

const ProductPage = () => {
  const api = '/product/products';
  const moduleCode = 'PRODUCT';
  const moduleName = 'Product';

  return (
    <>
      <div className={'page-wrapper'}>
        <HeaderFilter />
        <ProductTable
          api={api}
          moduleName={moduleName}
          moduleCode={moduleCode}
        />
        <ProductForm api={api} moduleName={moduleName} />
      </div>
    </>
  );
};

export default ProductPage;
